import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsCycleTimeClassicBoardRoute: InvariantJiraRoute = {
	name: 'software-reports-cycle-time-classic-board',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/cycle-time',
	exact: true,
};
